import { NavBar } from 'components/NavBar/NavBar'
import { clearEligibleEmployees, getFoodEligibleEmployees } from 'features/food/foodSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Flex, H1WithBack, PageFooter, PageWrapper, Table, Th, Tr } from 'styling/GlobalStyles'
import { getParams, handlePagination } from 'utils/helpers'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Td } from 'components/Td/Td'
import { Options } from 'components/Options/Options'
import { Pagination } from 'components/Pagination/Pagination'
import { FoodEmployeeSettingsModal, IFoodEmployeeSettingsModalState } from './FoodEmployeeSettingsModal'
import { IGetAllFoodEligibleEmployeesSingleResponse } from 'types/api/foodApi.interface'

export const FoodEligibleEmployees = () => {

    const [modal, setModal] = useState<{ open: boolean, value: IFoodEmployeeSettingsModalState }>({ open: false, value: null })
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { eligibleEmployees } = useSelector((store: RootState) => store.food)
    useQueryPagination({ fetchFunctions: [getFoodEligibleEmployees], cleanUpFunctions: [clearEligibleEmployees], params })

    const handleOpenModal = (item: IGetAllFoodEligibleEmployeesSingleResponse) => {
        setModal({
            open: true, value: {
                id: item?.id || null,
                maxMealsPerOperationalDay: item?.foodSettings?.maxMealsPerOperationalDay || null,
                provisioningMode: item.foodSettings?.id ? provisioningModes.find(p => item.foodSettings.provisioningMode == p.value) : null,
                foodSupplier: item.foodSettings?.foodSupplier?.id ? { label: item?.foodSettings?.foodSupplier?.name, value: item?.foodSettings?.foodSupplier?.id } : null,
                selectedMealTypes: item?.foodSettings?.selectedMealTypes.map(t => ({ value: t.mealType.id, label: t.mealType.name })) || [{ value: null, label: null }],
            }
        })
    }


    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <H1WithBack arrow title='Eligible Employees' />
            </Flex>
            {!eligibleEmployees.data?.length ? (
                <NoItems title='Eligible Employees' />
            ) : (
                <Table>
                    <Th>
                        <Td w='16%' noTooltip text='NAME' />
                        <Td w='16%' noTooltip text='SUPPLIER' />
                        <Td w='16%' noTooltip text='PROVISIONING MODE' />
                        <Td w='16%' noTooltip text='MAXIMUM MEALS PER DAY' />
                        <Td w='16%' noTooltip text='MEAL TYPES' />
                        <Td w='5%' />
                    </Th>
                    {eligibleEmployees.data?.map((item) => {
                        return (
                            <Tr key={item.id}>
                                <Td w='16%' text={item.firstName + ' ' + item.lastName} />
                                <Td w='16%' text={item.foodSettings?.foodSupplier?.name || '/'} />
                                <Td w='16%' text={provisioningModes.find(mode => mode.value === item?.foodSettings?.provisioningMode)?.label || '/'} />
                                <Td w='16%' text={item?.foodSettings?.maxMealsPerOperationalDay || '/'} />
                                <Td w='16%' text={item?.foodSettings?.selectedMealTypes?.map((type) => type.mealType.name).join(', ') || '/'} />
                                <Td options w='5%'>
                                    <Options item={item} title='Food Employee Settings' openModal={() => handleOpenModal(item)} />
                                </Td>
                            </Tr>
                        )
                    })}
                </Table>
            )}
            {modal.open && <FoodEmployeeSettingsModal closeModal={() => setModal({ open: false, value: null })} value={modal.value} />}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(eligibleEmployees.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}

export const provisioningModes = [{ value: 1, label: 'Mess Or Hall' }, { value: 2, label: 'Packout' }, { value: 3, label: 'OptOut' }]